import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useCardForTableStyles from 'app/tss/cardForTable'
import requestConfig from 'app/requests/Order/Order.requests'
import {
    WithId,
} from 'app/types/common.types'
import useLabel from 'app/hooks/useLabel'

import PreBookings from '../components/PreBookings'
import inboundOrdersConfig from './inboundOrders.config'
import outboundOrdersConfig from './outboundOrder.config'
import useStyles from './RelatedOrders.styles'

const RelatedOrders = ({
    id,
}: Readonly<WithId<number>>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()

    return (
        <>
            <Card
                className={cardClasses.root}
                title={l('OUTBOUND_ORDERS')}
            >
                <SkyNetTable
                    name="RelatedOrders-OutboundOrder"
                    tableConfig={outboundOrdersConfig}
                    customUrl={requestConfig.truckingCapacityOutbound().url}
                    simple
                    className={classes.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
            <PreBookings
                serviceCenterId={id}
                className={classes.table}
            />
            <Card
                className={cardClasses.root}
                title={l('INBOUND_ORDERS')}
            >
                <SkyNetTable
                    name="RelatedOrders-InboundOrder"
                    tableConfig={inboundOrdersConfig}
                    customUrl={requestConfig.truckingCapacityInbound().url}
                    simple
                    className={classes.table}
                    filters={{
                        serviceCenterId: id,
                    }}
                    showSearch
                />
            </Card>
        </>
    )
}

export default RelatedOrders
